import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObjectResponse } from '../interfaces';
import { Policy } from '../models';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class PoliciesService {

  private _userPoliciesList: Policy[];
  private _containerPolicies: Policy[];

  constructor(
    private _http: HttpClient,
    private _appConfig: AppConfig
  ) { }

  init(): void {
    this._userPoliciesList = null;
    this._containerPolicies = null;
  }

  getUserPolicies(): Observable<Policy[]> {
    const apiUrl = `${this.getUserResourceUrl()}/policies`;

    if (this._userPoliciesList) {
      return of(this._userPoliciesList);
    } else {
      return this._http.get<ObjectResponse<Policy[]>>(apiUrl).pipe(map((policies) => {
        this._userPoliciesList = policies.data;
        return this._userPoliciesList;
      }));
    }
  }

  getContainerPolicies(): Observable<Policy[]> {
    const apiUrl = `${this.getContainerResourceUrl()}/policies`;

    if (this._containerPolicies) {
      return of(this._containerPolicies);
    } else {
      return this._http.get<ObjectResponse<Policy[]>>(apiUrl).pipe(map((policies) => {
        this._containerPolicies = policies.data;
        return this._containerPolicies;
      }));
    }
  }

  getUserResourceUrl(): string {
    return `${this._appConfig.getBaseApiUrl()}user`;
  }

  getContainerResourceUrl(): string {
    return `${this._appConfig.getBaseApiUrl()}containers`;
  }
}
